/**
 * TanStack Query hooks for `in-app-fraud-rules`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	inAppFraudRulesQueryKeys,
	type CreateInAppFraudRulesBody,
	type ListInAppFraudRulesResponse,
	type InAppFraudRulesRow,
} from "./api";

export function useInAppFraudRulesList(): UseQueryResult<ListInAppFraudRulesResponse, Error> {
	return useQuery({
		queryKey: inAppFraudRulesQueryKeys.list(),
		queryFn: list,
	});
}

export function useInAppFraudRulesCreate(): UseMutationResult<InAppFraudRulesRow, Error, CreateInAppFraudRulesBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: inAppFraudRulesQueryKeys.all });
		},
	});
}

export function useInAppFraudRulesDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: inAppFraudRulesQueryKeys.all });
		},
	});
}
